import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getViewSingleOrMultipleInvoicesCTA } from "./shared";

export const InvoiceBasicsIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (_context) => {
      return BASICS_OF_INVOICES(strictLocalize);
    },

    descriptionBuilder: (_context) => {
      return [INVOICES_EXPLANATION(strictLocalize)];
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getViewSingleOrMultipleInvoicesCTA(context, strictLocalize)
          ?.label;
      },
      linkBuilder: (context) => {
        return getViewSingleOrMultipleInvoicesCTA(
          context,
          strictLocalize
        )?.getLink?.(context.brandOrder);
      },
    },
  };
};

const BASICS_OF_INVOICES = (strictLocalize: StrictLocalizeFunction) => {
  if (getSettingRetailerExclusivityAgreements()) {
    return strictLocalize({
      defaultMessage: "About invoices",
      description: {
        text: "Title for the answer of how order invoices work at Faire",
      },
    });
  }

  return strictLocalize({
    defaultMessage: "Basics of Order Invoices at Faire",
    description: {
      text: "Title for the answer of how order invoices work at Faire",
    },
  });
};

const INVOICES_EXPLANATION = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "All retailers on Faire will receive an order invoice. Your invoice will be broken down into three main components i.e. Billing Information, Product Information and Payment Information. Check out the help center article for more details on each component. Click on the button to go to the invoice page. If you need more help, please contact us.",
    description: {
      text: "Description for the answer of how order invoices work at Faire",
    },
  });
